<template lang="pug">
v-container(
  v-sortable=`{
    handler: '.handler',
    container: '.layout',
    callback: onSorted
  }`
  class='pa-0'
  fluid
)
  v-layout(:class={ 'row wrap': true } style={ 'margin-top': 0 })
    slot(v-for='(v, k) in list' :item='v' name='item')
      v-flex(@click='openFullScreen(v)' class='with-pointer' xs12 sm3)
        v-card(class='handler d-flex sortable-card' :data-index='k')
          v-img(
            :src='v.url'
            :lazy-src='v.url'
            aspect-ratio='1'
            class='grey lighten-4 img-preview'
          )
            v-layout(
              slot='placeholder'
              fill-height align-center justify-center ma-0
            )
              v-progress-circular(indeterminate color='primary')
          
          div(class='controls pa-2' @click.stop)
            div(class='filename grey--text') {{ v.file_name }} 
            v-spacer
            v-btn(
              v-if='deletable'
              @click='removeFile(v)'
              icon
            )
              v-icon(color='grey') delete_outline
            v-menu(transition='slide-x-reverse-transition')
              v-btn(slot='activator' icon)
                v-icon(color='grey') info
              v-list(dense)
                v-list-tile(class='my-2')
                  v-list-tile-content
                    div(class='pr-5 grey--text') Название:
                    div {{ v.file_name }}
                v-list-tile(class='my-2')
                  v-list-tile-content
                    div(class='pr-5 grey--text') Скачать:
                    div
                      a(:href='v.url' :download='v.file_name' target='_blank')
                        | {{ v.url }}
                v-list-tile(class='my-2')
                  v-list-tile-content
                    div(class='pr-5 grey--text') Размер:
                    div {{ v.file_size }} Мбайт
  v-dialog(
    transition='slide-x-reverse-transition'
    v-model='dialog'
    fullscreen
    hide-overlay
  )
    v-card
      v-toolbar(flat color='white' class='toolbar' fixed prominent)
        v-btn(icon @click='closeFullScreen')
          v-icon close
        v-toolbar-title
      slot(name='details' :item='current')
        div(class='preview')
          v-img(
            :src='current.url'
            :lazy-src='current.url'
            class='grey lighten-4'
          )
            v-layout(slot='placeholder' fill-height align-center justify-center ma-0)
              v-progress-circular(indeterminate color='primary')
</template>

<script>
import http from '@/http'

export default {
  props: {
    sortable: {
      type: Array,
      default: () => []
    },
    openable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    updateServer: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    recordId: {
      type: Number
    }
  },

  data: () => ({
    list: [],
    current: {},
    dialog: false
  }),

  created() {
    this.list = this.value
  },

  methods: {
    openFullScreen(item) {
      if (this.openable) {
        this.dialog = true
        this.$nextTick(() => {
          this.current = item
        })
      }
    },

    closeFullScreen() {
      this.dialog = false
      this.current = {}
    },

    onSorted() {
      const indexes = [...this.$el.querySelectorAll('[data-index]')]
        .map(element => element.getAttribute('data-index'))
        .map(index => +index)

      const sortedResults = indexes.map(index => this.list[index])

      if (this.updateServer) {
        this.applySort(sortedResults)
      }

      this.$emit('change', sortedResults)
    },

    async removeFile(file) {
      
      if (this.updateServer) {
        if (!(await this.$confirm('Вы уверены?'))) return
        this.applyRemove(file)
      }

      this.$emit('remove', file)
    },

    async applyRemove(file) {
      if (this.busy) return
      this.busy = true
      try {
        await http.delete(`/files/delete/${file.hash}`, {
          record_id: this.recordId
        })

        const index = this.list.indexOf(file)
        this.$emit('remove-success', { file, index })

        if (this.updateServer) {
          const newList = this.list.filter((_, i) => i !== index)
          this.$emit('input', newList)
        }
      } catch (error) {
        this.$emit('remove-error', error)
      }

      this.busy = false
    },

    async applySort(files) {
      try {
        await http.post('/files/sort-ref', {
          record_id: this.recordId,
          files: files.map(file => file.hash)
        })
        this.$emit('sort-success', files)
      } catch (error) {
        this.$emit('sort-error', error)
      }
    }
  },

  watch: {
    sortable(val) {
      this.list = val
    },
    value(val) {
      if (this.updateServer) {
        this.list = val
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  z-index: 10;
}
.preview {
  padding: 64px;
}
.controls {
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
  position: absolute !important;
  background: white;
  display: flex;
  align-items: flex-end;
}
.controls .v-btn {
  margin: 0;
  margin-left: 8px;
}
.img-preview >>> .v-image__image{
  height: auto;
  bottom: 52px;
  background-size: contain;
  background-color: white;
}
.filename {
  line-height: 35px;
  font-size: 12px;
}
</style>
